import React, { useEffect, useState } from "react";
import { List } from "antd";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";
import apiService from "../../../../service/apiservice/apiService";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";

const AlertList = ({ carePlanId, setShowAlert }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [alertList, setAlertList] = useState([]);
  const [careplan, setCareplan] = useState({});
  const [loading, setLoading] = useState(false);

  const handleDismisClick = async (item) => {
    setLoading(true);
    try {
      const metadata = JSON.parse(careplan?.metadata || "{}");

      const dismissedAlerts = {
        ...metadata?.dismissedAlerts,
        [item?.key]: true,
      };

      const response = await apiService.post(
        "niramayafoundation/niramayavisits/api/v1/careplan",
        {
          ...careplan,
          id: careplan?.id,
          metadata: JSON.stringify({ ...metadata, dismissedAlerts }),
          alerts: true,
        }
      );
      if (!response?.alerts?.length) {
        setShowAlert(false);
      }
      setAlertList(response?.alerts || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getCarePlan = async () => {
      setLoading(true);
      const endpoint = "niramayafoundation/niramayavisits/api/v1/careplans";
      const params = {
        organizationIdentifier,
        carePlanId,
        alerts: true,
      };
      const response = await apiService.get(endpoint, params);

      if (response[0]?.id) {
        setCareplan(response[0]);
        setAlertList(response[0]?.alerts || []);
      }
      setLoading(false);
    };

    getCarePlan();
  }, [carePlanId, organizationIdentifier]);

  return (
    <List
      loading={loading}
      dataSource={alertList}
      renderItem={(item) => (
        <List.Item>
          <div className="notification-bubble">
            <div className="notification-text-wrapper">
              <div className="notification-text">
                {item?.type.toUpperCase()}
              </div>
              <div>
                <SmartIcon
                  iconKey="reject"
                  width="16"
                  height="16"
                  handleIconClick={() => handleDismisClick(item)}
                />
              </div>
            </div>
            <div className="notification-text">{item?.message}</div>
          </div>
        </List.Item>
      )}
    />
  );
};

export default AlertList;
